/* eslint-disable @typescript-eslint/no-explicit-any */
import {createSlice} from '@reduxjs/toolkit'
import {refreshAccessToken} from '../action/authActions'
import {toast} from 'react-toastify'

type IPayload = {
 accessToken: string | null
 refreshToken: string | null
 mobileNo: string
 userId: string
 accessExpiresIn: number
 refreshExpiresIn: number
 data: never[]
 status: string
 error: null
 loading: boolean
 message: string
}

const initialState = {
 accessToken: localStorage.getItem('accessToken') ?? null,
 refreshToken: localStorage.getItem('refreshToken') ?? null,
 accessExpiresIn: parseInt(
  localStorage.getItem('accessExpiresIn') ?? '0'
 ),
 refreshExpiresIn: parseInt(
  localStorage.getItem('refreshExpiresIn') ?? '0'
 ),
 data: [],
 status: 'idle',
 error: null,
 mobileNo: '',
 userId: '',
 loading: false,
 message: '',
}

const authSlice = createSlice({
 name: 'auth',
 initialState,
 reducers: {
  setOTPData: (state, action) => {
   const actions: IPayload = action.payload
   state.mobileNo = actions.mobileNo
   state.userId = actions.userId
  },
  setTokens: (state, action) => {
   const actions: IPayload = action.payload.results
   state.accessToken = actions.accessToken
   state.refreshToken = actions.refreshToken
   state.accessExpiresIn = actions.accessExpiresIn
   state.refreshExpiresIn = actions.refreshExpiresIn
  },
  clearTokens: (state) => {
   state.accessToken = null
   state.refreshToken = null
   state.accessExpiresIn = 0
   state.refreshExpiresIn = 0
  },
 },
 extraReducers: (builder) => {
  builder
   .addCase(refreshAccessToken.pending, (state) => {
    state.loading = true
   })
   .addCase(
    refreshAccessToken.fulfilled,
    (state, action: any) => {
     state.accessToken = action.payload.results.accessToken
     state.refreshToken =
      action.payload.results.refreshToken
     state.accessExpiresIn =
      action.payload.results.accessExpiresIn
     state.refreshExpiresIn =
      action.payload.results.refreshExpiresIn
     state.loading = false
    }
   )
   .addCase(refreshAccessToken.rejected, (state) => {
    state.status = 'failed'
    state.loading = false
    toast.error(
     'Something went wrong! or Connection request Error!'
    )
   })
 },
})

export const {setTokens, clearTokens, setOTPData} =
 authSlice.actions

export default authSlice.reducer
